var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewCover',{staticStyle:{"height":"100%","overflow":"hidden"}},[_c('ScrollHandler',[_c('iframe',{key:"iframe_doc",ref:"scroller",staticClass:"documentation",attrs:{"frameborder":"0","width":"100%","height":"98%","src":"https://wiki.carbis.ru/external/prodelivery"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }